ModelCache = require 'db/model-cache'
React = require 'react'
xtend = require 'xtend'

module.exports = (ComposedComponent) -> class extends React.Component
  constructor: (props) ->
    super
    @listeners = []
    @modelListeners = []

  listenTo: (events, callback) ->
    ModelCache.on events, callback
    @listeners.push
      events: events
      callback: callback

  modelListener: (model, events, callback) ->
    model.on events, callback
    @modelListeners.push {
      model
      events
      callback
    }

  clearModelListeners: ->
    @modelListeners.forEach ({ model, events, callback }) ->
      model.off events, callback

  componentWillUnmount: ->
    @listeners.forEach(({ events, callback }) -> ModelCache.off events, callback)
    @clearModelListeners()

  render: ->
    newProps = xtend @props,
      listenTo: @listenTo.bind(@)
      modelListener: @modelListener.bind(@)
      clearModelListeners: @clearModelListeners.bind(@)

    React.createElement ComposedComponent, newProps




// WEBPACK FOOTER //
// ./app/scripts/views/internal/model-cache-listener.coffee